<template>
  <PrintPageLandscape>
    <PresentationPage :page-number="pageNumber" :page-count="pageCount">
      <p class="presentation-page__eyebrow">Selbstauskunft</p>
      <h2 class="presentation-page__title">Selbstauskunft — Immobilienvermögen</h2>
      <p class="presentation-page__text">
        Erfassung der bestehenden Immobilienbestände und damit verbundenen Belastungen.
      </p>
      <div class="presentation-page__form">
        <div class="presentation-page__form-header">Selbstauskunft — Immobilienvermögen</div>
        <div class="presentation-page__form-body">
          <section
            v-for="section in sections"
            :key="section.title"
            class="presentation-page__form-section"
          >
            <h3 class="presentation-page__form-section-title">{{ section.title }}</h3>
            <div class="presentation-page__form-fields">
              <div
                v-for="field in section.fields"
                :key="field.label"
                class="presentation-page__form-field"
              >
                <label class="presentation-page__form-field-label">{{ field.label }}</label>
                <div class="presentation-page__form-field-input" aria-hidden="true"></div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <p class="presentation-page__disclaimer">
        Vorlage zur Erfassung beim Erstgespräch — wird im RETIS-System digital strukturiert
        weitergeführt.
      </p>
    </PresentationPage>
  </PrintPageLandscape>
</template>

<script>
import PrintPageLandscape from '@/components/Print/PrintPageLandscape.vue';
import PresentationPage from '@/views/MasterPresentation/PresentationPage';

export default {
  name: 'MasterPresentationPrintPage42',
  components: { PrintPageLandscape, PresentationPage },
  props: {
    project: { type: Object, default: null },
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },
  data() {
    return {
      sections: [
        {
          title: 'Objekt 1 — Selbst genutzt',
          fields: [
            { label: 'Adresse' },
            { label: 'Verkehrswert' },
            { label: 'Restschuld' },
            { label: 'Monatsrate' },
          ],
        },
        {
          title: 'Objekt 2 — Vermietet',
          fields: [
            { label: 'Adresse' },
            { label: 'Verkehrswert' },
            { label: 'Restschuld' },
            { label: 'Mieteinnahmen' },
          ],
        },
        {
          title: 'Sonstiges Immobilienvermögen',
          fields: [
            { label: 'Art / Lage' },
            { label: 'Marktwert' },
            { label: 'Belastung' },
            { label: 'Anteil %' },
          ],
        },
      ],
    };
  },
};
</script>
